<svg width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="20.0002" cy="20" r="19.1667" stroke="#000" />
  <path d="M27.5 21.1458V14.8958H12.5V27.3958H20" stroke="#000" stroke-width="1.13883" />
  <path
    d="M16.25 14.8959C16.25 14.4792 16.25 13.8125 16.25 12.8125C16.25 11.5625 18.3333 10.7292 20 10.7292C21.6667 10.7292 23.75 11.5625 23.75 12.8125C23.75 13.8125 23.75 14.4792 23.75 14.8959"
    stroke="#000" stroke-width="1.13883" />
  <path d="M21.5625 24.6874H27.8125" stroke="#000" />
  <path d="M24.6875 21.5624V27.8124" stroke="#000" />
</svg>
